/** Issue groups with a meaning outside the rule that raised the issue. */
export const ValidationIssueGroup = {
  /** A finding of the AI analysis; its message is written by the model. */
  AI_ANALYSIS: 'AI_ANALYSIS'
} as const;

export type ValidationIssueGroup = (typeof ValidationIssueGroup)[keyof typeof ValidationIssueGroup];
